import { GIFT_GUIDE_FEATURED_DEALS_GET_SUCCESS, GIFT_GUIDE_FEATURED_DEALS_GET_FAILURE } from '../actions/types';

const initialState = {
  isLoading: false,
  isLoaded: false,
  placements: [],
};

const giftGuideFeaturedDeals = (state = initialState, action) => {
  switch (action.type) {
    case GIFT_GUIDE_FEATURED_DEALS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placements: action.payload.response,
      };
    }
    case GIFT_GUIDE_FEATURED_DEALS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placements: [],
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === GIFT_GUIDE_FEATURED_DEALS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }
    }
  }

  return state;
};

export default giftGuideFeaturedDeals;
